import React from 'react';
import { AboutUsTitle, AboutUsWrapper, FeatureTitle, FeaturesList, MarketLabel, MoneyBackDescription,  MoneyBackTitle, MoneyBackWrapper, PressLogos, ReviewBody, ReviewHead, ReviewItem, ReviewText, ReviewTitle, ReviewWrapper, ReviewerName, ReviewerPhoto, StyledBtn, StyledItem, TrialHint } from './styles/descriptionStyles';
import { MoneyBack, AndroidLogo, IosLogo, AppIcon, StarsIcon, FeatureIcon, ForbesIcon, MashableIcon, TechCrunchIcon } from './styles/icons';
const PlansDescription = ({ continueButton, showHint, btnAfter }) => {
    const onLinkClick = (url) => window.open(url);
    const FEATURES = [
        'Know when family come or go',
        'Real-time location sharing',
        'Find loved ones in a crowd',
        'Be notified in case of an emergency',
        'Track their car speed in real time',
        'Know if loved ones get hurt',
        'See the history of whereabouts',
        'Pair with Geozilla supported devices',
        'Notify your family about your current location',
    ];
    const renderFeature = (i, index) => (
        <StyledItem key={index}>
            {FeatureIcon}
            <span>{i}</span>
        </StyledItem>
    );
    const REVIEWS = [
        {
            market: 'ios',
            reviewer: 'John Eydman',
            reviewerSource: '../images/plans/reviewer1.png',
            text: 'Great app for keeping up with teens that are always on the move between sports, school and friends. After using an app for 3 weeks, it has worked flawlessly.',
        },
        {
            market: 'ios',
            reviewer: 'Chris Topper',
            reviewerSource: '../images/plans/reviewer2.png',
            text: 'Perfect for android to iphone.I have dementia in the early stages :( This will helpin the future for my family.',
        },
        {
            market: 'android',
            reviewer: 'Jane Stevenson',
            reviewerSource: '../images/plans/reviewer3.png',
            text: 'Useful for parents to keep tabs on minors and elderly family members... Displaying physical addreses at each tracking location along a route is impressive...',
        },
    ];
    const renderReview = (r, i) => (
        <ReviewItem key={i}>
            <ReviewHead>
                {AppIcon}
                {StarsIcon}
                <MarketLabel>
                    {r.market === 'ios' ? IosLogo : AndroidLogo}
                </MarketLabel>
            </ReviewHead>
            <ReviewBody>
                <ReviewerPhoto src={r.reviewerSource} alt={r.reviewer} />
                <ReviewerName>{r.reviewer}</ReviewerName>
            </ReviewBody>
            <ReviewText>{r.text}</ReviewText>
        </ReviewItem>
    );
    const trialHint = <TrialHint show={showHint}>{showHint}</TrialHint>;
    return (
        <>
            <FeatureTitle btnAfter={btnAfter}>What you get</FeatureTitle>
            <FeaturesList btnAfter={btnAfter}>
                {FEATURES.map(renderFeature)}
            </FeaturesList>
            {btnAfter && continueButton(true, 'sticky')}
            <MoneyBackWrapper btnAfter={btnAfter}>
                {MoneyBack}
                <MoneyBackTitle>100% Money-Back Guarantee</MoneyBackTitle>
                <MoneyBackDescription>
                     Our primary focus is providing our users with high-quality location sharing features. We offer a money-back guarantee if our app does not perform correctly. For more information, please read our&nbsp;
                    <StyledBtn onClick={() => onLinkClick('https://geozilla.com/terms-of-use/')}
                        id="link-to-terms"
                    >
                        Terms of Use
                    </StyledBtn>
                </MoneyBackDescription>
            </MoneyBackWrapper>
            <AboutUsWrapper>
                <AboutUsTitle>They write about us</AboutUsTitle>
                <PressLogos>
                    <div>
                        {ForbesIcon} 
                        {MashableIcon} 
                    </div>
                    {TechCrunchIcon}
                </PressLogos>
            </AboutUsWrapper>
            <ReviewWrapper>
                <ReviewTitle>Customer reviews</ReviewTitle>
                {REVIEWS.map(renderReview)}
            </ReviewWrapper>
            {continueButton(false)}
            {trialHint}
        </>
    );
};

export default PlansDescription;
